<div class="progress-stepper my-3 mx-auto">
  <div class="progress-track d-flex w-100">
    <div class="progress-segment" *ngFor="let filled of segments" [class.filled]="filled"></div>
  </div>
  <p class="progress-label mt-3 mb-0 fw-bold rounded-pill">
    <span
      class="progress-icon flex-shrink-0"
      [style.--progress-icon-url]="'url(' + icon + ')'"
      aria-hidden="true"
    ></span>
    {{ label }}
  </p>
</div>